<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con01">
<h2 class="contentsHead">Contents</h2>
<div class="contentsEntry">
<p class="contentsEntryName"><a href="#/xhtml/epigraph#epi01">Epigraph</a></p>
</div>
<div class="contentsEntry" id="fm_01">
<p class="contentsEntryName"><a href="#/xhtml/prologue#fm01">Prologue</a></p>
</div>
<div class="contentsEntry" id="ch_01">
<p class="contentsEntryNumber"><a href="#/xhtml/chapter01#ch01">Chapter 1</a></p>
<p class="contentsEntryName">The Magic Band</p>
</div>
<div class="contentsEntry" id="ch_02">
<p class="contentsEntryNumber"><a href="#/xhtml/chapter02#ch02">Chapter 2</a></p>
<p class="contentsEntryName">Call 2344, Thursday, 12:23 A.M.</p>
</div>
<div class="contentsEntry" id="ch_03">
<p class="contentsEntryNumber"><a href="#/xhtml/chapter03#ch03">Chapter 3</a></p>
<p class="contentsEntryName">The Past Encroaches</p>
</div>
<div class="contentsEntry" id="ch_04">
<p class="contentsEntryNumber"><a href="#/xhtml/chapter04#ch04">Chapter 4</a></p>
<p class="contentsEntryName">1990 Metallic Green Ford Taurus</p>
</div>
<div class="contentsEntry" id="ch_05">
<p class="contentsEntryNumber"><a href="#/xhtml/chapter05#ch05">Chapter 5</a></p>
<p class="contentsEntryName">1990 Black Volvo Model 740</p>
</div>
<div class="contentsEntry" id="ch_06">
<p class="contentsEntryNumber"><a href="#/xhtml/chapter06#ch06">Chapter 6</a></p>
<p class="contentsEntryName">12:34 P.M.</p>
</div>
<div class="contentsEntry" id="ch_07">
<p class="contentsEntryNumber"><a href="#/xhtml/chapter07#ch07">Chapter 7</a></p>
<p class="contentsEntryName">12:51 P.M.</p>
</div>
<div class="contentsEntry" id="ch_08">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter08#ch08" title="Link target outside of Sample">Chapter 8</span></p>
<p class="contentsEntryName">A Voice at Thirty Thousand Feet</p>
</div>
<div class="contentsEntry" id="ch_09">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter09#ch09" title="Link target outside of Sample">Chapter 9</span></p>
<p class="contentsEntryName">Dead Kennedys in an Ambulance</p>
</div>
<div class="contentsEntry" id="ch_10">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Chapter 10</span></p>
<p class="contentsEntryName">St. Michael’s Hospital</p>
</div>
<div class="contentsEntry" id="ch_11">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Chapter 11</span></p>
<p class="contentsEntryName">Helicopter Wishes</p>
</div>
<div class="contentsEntry" id="ch_12">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Chapter 12</span></p>
<p class="contentsEntryName">A Dark Happiness</p>
</div>
<div class="contentsEntry" id="ch_13">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Chapter 13</span></p>
<p class="contentsEntryName">Minibar, Maxi-Problem</p>
</div>
<div class="contentsEntry" id="ch_14">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">Chapter 14</span></p>
<p class="contentsEntryName">The Interview</p>
</div>
<div class="contentsEntry" id="ch_15">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">Chapter 15</span></p>
<p class="contentsEntryName">The Confession</p>
</div>
<div class="contentsEntry" id="ch_16">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">Chapter 16</span></p>
<p class="contentsEntryName">My Other Girlfriend</p>
</div>
<div class="contentsEntry" id="ch_17">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">Chapter 17</span></p>
<p class="contentsEntryName">Call 1288, 12:22 A.M. Sandy’s Music</p>
</div>
<div class="contentsEntry" id="ch_18">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">Chapter 18</span></p>
<p class="contentsEntryName">The Prison of Conventions</p>
</div>
<div class="contentsEntry" id="ch_19">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">Chapter 19</span></p>
<p class="contentsEntryName">Finding Alondra</p>
</div>
<div class="contentsEntry" id="ch_20">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">Chapter 20</span></p>
<p class="contentsEntryName">Tattooed</p>
</div>
<div class="contentsEntry" id="ch_21">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample">Chapter 21</span></p>
<p class="contentsEntryName">Call 2305, Friday, 1:35 A.M. The Soldier</p>
</div>
<div class="contentsEntry" id="ch_22">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter22#ch22" title="Link target outside of Sample">Chapter 22</span></p>
<p class="contentsEntryName">Habit and Change</p>
</div>
<div class="contentsEntry" id="ch_23">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter23#ch23" title="Link target outside of Sample">Chapter 23</span></p>
<p class="contentsEntryName">The Contract</p>
</div>
<div class="contentsEntry" id="ch_24">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter24#ch24" title="Link target outside of Sample">Chapter 24</span></p>
<p class="contentsEntryName">A Peculiar Exchange</p>
</div>
<div class="contentsEntry" id="ch_25">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter25#ch25" title="Link target outside of Sample">Chapter 25</span></p>
<p class="contentsEntryName">A Night at the Station</p>
</div>
<div class="contentsEntry" id="ch_26">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter26#ch26" title="Link target outside of Sample">Chapter 26</span></p>
<p class="contentsEntryName">Euphoria</p>
</div>
<div class="contentsEntry" id="ch_27">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter27#ch27" title="Link target outside of Sample">Chapter 27</span></p>
<p class="contentsEntryName">Miscalculation</p>
</div>
<div class="contentsEntry" id="ch_28">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter28#ch28" title="Link target outside of Sample">Chapter 28</span></p>
<p class="contentsEntryName">Call 3307, Tuesday, 4:02 A.M. The Ghost Bride</p>
</div>
<div class="contentsEntry" id="ch_29">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter29#ch29" title="Link target outside of Sample">Chapter 29</span></p>
<p class="contentsEntryName">The Police Operation</p>
</div>
<div class="contentsEntry" id="ch_30">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter30#ch30" title="Link target outside of Sample">Chapter 30</span></p>
<p class="contentsEntryName">The Rescue</p>
</div>
<div class="contentsEntry" id="ch_31">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter31#ch31" title="Link target outside of Sample">Chapter 31</span></p>
<p class="contentsEntryName">Return to the City of Palaces</p>
</div>
<div class="contentsEntry" id="ch_32">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter32#ch32" title="Link target outside of Sample">Chapter 32</span></p>
<p class="contentsEntryName">Quantum Flux</p>
</div>
<div class="contentsEntry" id="ch_33">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter33#ch33" title="Link target outside of Sample">Chapter 33</span></p>
<p class="contentsEntryName">Miss Wikipedia and the Urban Legends</p>
</div>
<div class="contentsEntry" id="ch_34">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter34#ch34" title="Link target outside of Sample">Chapter 34</span></p>
<p class="contentsEntryName">Call 2412, Friday, 2:15 A.M. Icy Cliff</p>
</div>
<div class="contentsEntry" id="ch_35">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter35#ch35" title="Link target outside of Sample">Chapter 35</span></p>
<p class="contentsEntryName">Ghost Radio Genesis</p>
</div>
<div class="contentsEntry" id="ch_36">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter36#ch36" title="Link target outside of Sample">Chapter 36</span></p>
<p class="contentsEntryName">Why Watt?</p>
</div>
<div class="contentsEntry" id="ch_37">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter37#ch37" title="Link target outside of Sample">Chapter 37</span></p>
<p class="contentsEntryName">Call 1904, Monday, 4:01 A.M. The Translator</p>
</div>
<div class="contentsEntry" id="ch_38">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter38#ch38" title="Link target outside of Sample">Chapter 38</span></p>
<p class="contentsEntryName">The Call</p>
</div>
<div class="contentsEntry" id="ch_39">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter39#ch39" title="Link target outside of Sample">Chapter 39</span></p>
<p class="contentsEntryName">Drains and Ladders</p>
</div>
<div class="contentsEntry" id="ch_40">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter40#ch40" title="Link target outside of Sample">Chapter 40</span></p>
<p class="contentsEntryName">Where’d Everybody Go?</p>
</div>
<div class="contentsEntry" id="ch_41">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter41#ch41" title="Link target outside of Sample">Chapter 41</span></p>
<p class="contentsEntryName">Return to the Past</p>
</div>
<div class="contentsEntry" id="ch_42">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter42#ch42" title="Link target outside of Sample">Chapter 42</span></p>
<p class="contentsEntryName">Inside the Cannibal Hospital</p>
</div>
<div class="contentsEntry" id="ch_43">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter43#ch43" title="Link target outside of Sample">Chapter 43</span></p>
<p class="contentsEntryName">The Nonexistent Show</p>
</div>
<div class="contentsEntry" id="ch_44">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter44#ch44" title="Link target outside of Sample">Chapter 44</span></p>
<p class="contentsEntryName">Another Broadcast</p>
</div>
<div class="contentsEntry" id="ch_45">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter45#ch45" title="Link target outside of Sample">Chapter 45</span></p>
<p class="contentsEntryName">Call 2109, Wednesday, 3:22 A.M. Dollhouse</p>
</div>
<div class="contentsEntry" id="ch_46">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter46#ch46" title="Link target outside of Sample">Chapter 46</span></p>
<p class="contentsEntryName">The Backyard Desert</p>
</div>
<div class="contentsEntry" id="ch_47">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter47#ch47" title="Link target outside of Sample">Chapter 47</span></p>
<p class="contentsEntryName">Radio Shaman</p>
</div>
<div class="contentsEntry" id="ch_48">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter48#ch48" title="Link target outside of Sample">Chapter 48</span></p>
<p class="contentsEntryName">Call 1288, Monday, 2:13 A.M. Lucy’s Apple</p>
</div>
<div class="contentsEntry" id="ch_49">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter49#ch49" title="Link target outside of Sample">Chapter 49</span></p>
<p class="contentsEntryName">Memories of Colett</p>
</div>
<div class="contentsEntry" id="ch_50">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter50#ch50" title="Link target outside of Sample">Chapter 50</span></p>
<p class="contentsEntryName">A Security Hazard</p>
</div>
<div class="contentsEntry" id="ch_51">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter51#ch51" title="Link target outside of Sample">Chapter 51</span></p>
<p class="contentsEntryName">A Ghost in the Machine</p>
</div>
<div class="contentsEntry" id="ch_52">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter52#ch52" title="Link target outside of Sample">Chapter 52</span></p>
<p class="contentsEntryName">When the Plane Landed, Joaquin was Asleep</p>
</div>
<div class="contentsEntry" id="ch_53">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter53#ch53" title="Link target outside of Sample">Chapter 53</span></p>
<p class="contentsEntryName">The Confrontation</p>
</div>
<div class="contentsEntry" id="ch_54">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter54#ch54" title="Link target outside of Sample">Chapter 54</span></p>
<p class="contentsEntryName">The Other Side</p>
</div>
<div class="contentsEntry" id="ch_55">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter55#ch55" title="Link target outside of Sample">Chapter 55</span></p>
<p class="contentsEntryName">After the Show</p>
</div>
<div class="contentsEntry1" id="ack_01">
<p class="contentsEntryName"><span href="#/xhtml/acknowledgments#ack01" title="Link target outside of Sample">Acknowledgments</span></p>
</div>
<div class="contentsEntry1" id="ata_01">
<p class="contentsEntryName"><span href="#/xhtml/aboutauthor#ata01" title="Link target outside of Sample">About the Author</span></p>
</div>
<div class="contentsEntry1" id="cre_01">
<p class="contentsEntryName"><span href="#/xhtml/credits#cre01" title="Link target outside of Sample">Credits</span></p>
</div>
<div class="contentsEntry1" id="cop_01">
<p class="contentsEntryName"><span href="#/xhtml/copyright#cop01" title="Link target outside of Sample">Copyright</span></p>
</div>
<div class="contentsEntry1" id="atp_01">
<p class="contentsEntryName"><span href="#/xhtml/aboutPublisher#atp01" title="Link target outside of Sample">About the Publisher</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?f38e9a46